var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegeEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9965 12.798V28.7733C28.8234 29.2291 28.4914 29.4199 28.0039 29.4199C19.3288 29.4164 10.6501 29.4199 1.9749 29.4164C1.31437 29.4164 1 29.0984 1 28.4447C1 23.3492 1 18.2503 1 13.1549C1 12.5083 1.31084 12.1938 1.95017 12.1938C3.82932 12.1938 5.70493 12.1938 7.58408 12.1938C7.68298 12.1938 7.77835 12.1938 7.88432 12.1938V8.78035C7.38274 8.92876 6.90589 9.07363 6.42904 9.20791C5.95925 9.33865 5.54598 9.1231 5.40116 8.68494C5.24221 8.19731 5.50713 7.77328 6.07935 7.60367C8.71086 6.81922 11.3424 6.03123 13.9774 5.25384C14.1823 5.19377 14.2423 5.10897 14.2388 4.89695C14.2247 4.10543 14.2317 3.31038 14.2317 2.51886C14.2317 1.84042 14.3377 1.67434 14.9452 1.41992H20.4697C20.731 1.533 20.9783 1.65314 21.0949 1.94289C21.3245 2.50473 20.9288 3.0701 20.2789 3.07363C18.9225 3.0807 17.5626 3.07363 16.2063 3.07363C16.1003 3.07363 15.9943 3.07363 15.8848 3.07363V5.16904C17.3224 5.5966 18.7495 6.02416 20.1765 6.45172C21.4763 6.84042 22.7727 7.22911 24.0725 7.61427C24.4364 7.72381 24.6907 7.93229 24.7295 8.32805C24.7931 8.94289 24.2774 9.37045 23.6734 9.20437C23.1577 9.06303 22.6455 8.90402 22.1192 8.74854V12.1938H22.4336C24.2668 12.1938 26.0965 12.2044 27.9297 12.1867C28.4313 12.1796 28.7916 12.3316 29 12.798H28.9965ZM20.4591 27.7591V27.4553C20.4591 21.1478 20.4591 14.8369 20.4626 8.52946C20.4626 8.32098 20.4061 8.22911 20.2012 8.16904C18.5517 7.68494 16.9056 7.18671 15.2561 6.70261C15.1254 6.66374 14.9664 6.66727 14.8357 6.70614C13.1685 7.19731 11.5049 7.70261 9.83764 8.18671C9.60805 8.25384 9.52327 8.33865 9.52681 8.586C9.53387 14.8758 9.53387 21.169 9.53387 27.4588C9.53387 27.5542 9.53387 27.6531 9.53387 27.7591H11.3353C11.3353 27.6355 11.3353 27.5295 11.3353 27.4235C11.3353 25.7556 11.3247 24.0878 11.3388 22.4164C11.36 20.1266 13.4758 18.427 15.7153 18.8828C17.4249 19.2291 18.6117 20.7061 18.6258 22.5224C18.6364 24.162 18.6258 25.8051 18.6258 27.4447C18.6258 27.5507 18.6364 27.6531 18.64 27.7591H20.4555H20.4591ZM7.87725 27.7591V13.851H2.65662V27.7591H7.87725ZM22.1192 13.8404V27.7521H27.3398V13.8404H22.1192ZM12.9955 27.7697C14.2918 27.7697 15.5563 27.7697 16.8209 27.7697C17.0045 27.7697 16.9939 27.6567 16.9939 27.533C16.9939 26.9959 16.9939 26.4588 16.9939 25.9217C16.9939 24.8015 16.9904 23.6814 16.9939 22.5577C16.9939 21.8121 16.7255 21.2008 16.0968 20.7874C15.4433 20.3528 14.7404 20.3174 14.0516 20.6814C13.3487 21.0524 12.9884 21.6673 12.9813 22.4623C12.9707 24.1584 12.9778 25.851 12.9813 27.5471C12.9813 27.6107 12.9884 27.6708 12.9955 27.7697Z",
    fill: "url(#paint0_linear_501_79)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 14.397C18.287 15.984 16.988 17.238 15.431 17.196C13.829 17.154 12.599 15.837 12.644 14.214C12.686 12.687 14.036 11.448 15.602 11.499C17.123 11.547 18.38 12.879 18.335 14.397ZM15.482 12.891C14.678 12.894 14.03 13.554 14.036 14.367C14.042 15.159 14.705 15.813 15.497 15.807C16.289 15.801 16.943 15.147 16.946 14.352C16.949 13.551 16.286 12.888 15.482 12.894V12.891Z",
    fill: "url(#paint1_linear_501_79)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55702 22.5149C6.55702 22.0499 6.55702 21.5849 6.55702 21.1229C6.55702 20.8349 6.62302 20.7719 6.91402 20.7689C7.16302 20.7689 7.40902 20.7689 7.65802 20.7689C7.85602 20.7689 7.96102 20.8559 7.96102 21.0629C7.96102 22.0289 7.96102 22.9979 7.96102 23.9639C7.96102 24.1589 7.85302 24.2489 7.67302 24.2549C7.40302 24.2609 7.13002 24.2609 6.86002 24.2549C6.65302 24.2519 6.55102 24.1469 6.55402 23.9339C6.56002 23.4629 6.55402 22.9889 6.55402 22.5179L6.55702 22.5149Z",
    fill: "url(#paint2_linear_501_79)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.557 17.3909C6.557 16.9409 6.557 16.4939 6.557 16.0439C6.557 15.7319 6.62 15.6689 6.941 15.6689C7.181 15.6689 7.421 15.6689 7.661 15.6689C7.862 15.6689 7.961 15.7649 7.961 15.9659C7.961 16.9259 7.961 17.8859 7.961 18.8459C7.961 19.0589 7.856 19.1579 7.646 19.1549C7.391 19.1549 7.136 19.1549 6.881 19.1549C6.644 19.1519 6.56 19.0679 6.557 18.8339C6.554 18.3539 6.557 17.8739 6.557 17.3939V17.3909Z",
    fill: "url(#paint3_linear_501_79)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.491 22.5269C24.491 22.9829 24.491 23.4389 24.491 23.8979C24.491 24.1739 24.41 24.2549 24.131 24.2579C23.891 24.2609 23.651 24.2639 23.411 24.2579C23.174 24.2519 23.087 24.1679 23.087 23.9339C23.087 22.9829 23.087 22.0289 23.087 21.0779C23.087 20.8619 23.189 20.7689 23.402 20.7719C23.657 20.7749 23.912 20.7719 24.167 20.7719C24.422 20.7749 24.491 20.8499 24.494 21.1109C24.494 21.5819 24.494 22.0559 24.494 22.5269H24.491Z",
    fill: "url(#paint4_linear_501_79)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.084 17.4179C23.084 16.9469 23.084 16.4729 23.084 16.0019C23.084 15.7439 23.156 15.6749 23.417 15.6719C23.666 15.6719 23.912 15.6689 24.161 15.6719C24.404 15.6749 24.485 15.7529 24.488 15.9899C24.488 16.9409 24.488 17.8949 24.488 18.8459C24.488 19.0589 24.383 19.1579 24.173 19.1579C23.918 19.1579 23.663 19.1579 23.408 19.1579C23.168 19.1549 23.084 19.0739 23.084 18.8369C23.081 18.3659 23.084 17.8919 23.084 17.4209V17.4179Z",
    fill: "url(#paint5_linear_501_79)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_501_79",
    x1: 15,
    y1: 1.41992,
    x2: 15,
    y2: 29.4199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_501_79",
    x1: 15.4895,
    y1: 11.4974,
    x2: 15.4895,
    y2: 17.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_501_79",
    x1: 7.25749,
    y1: 20.7689,
    x2: 7.25749,
    y2: 24.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_501_79",
    x1: 7.25833,
    y1: 15.6689,
    x2: 7.25833,
    y2: 19.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_501_79",
    x1: 23.7905,
    y1: 20.7719,
    x2: 23.7905,
    y2: 24.2614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_501_79",
    x1: 23.7853,
    y1: 15.6705,
    x2: 23.7853,
    y2: 19.1579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeEducation);
export default __webpack_public_path__ + "static/media/college_education.6b911416122bd53d1dc4f3ca6b843886.svg";
export { ForwardRef as ReactComponent };